// Real BEA Governing Body / leadership roster from the About > Leadership
// section source set (leadership.xlsx). Photos live in biet-media
// (sites/biet/leadership/); <Figure> falls back to a placeholder for any
// member without one. lNo is the source-set numbering key. Roles are
// verbatim from the source (BEA governance roles), which may differ from a
// member's institute title (e.g. Dr. H.B. Aravind is "Secretary" here but
// heads the Principal's letter above).
import type { Media } from "@zivin-labs/site-content";

export interface BoardMember {
  lNo: string;
  name: string;
  role: string;
  photo?: Media;
}

export const BOARD: BoardMember[] = [
  { lNo: "L01", name: "Late Dr. Shamanur Shivashankarappa", role: "Former Hon. Secretary and Chairman", photo: { url: "sites/biet/leadership/l01.jpg", alt: "Late Dr. Shamanur Shivashankarappa, Former Hon. Secretary and Chairman", width: 1738, height: 2170 } },
  { lNo: "L02", name: "Sri S.S. Mallikarjuna", role: "Chairman", photo: { url: "sites/biet/leadership/l02.jpg", alt: "Sri S.S. Mallikarjuna, Chairman", width: 1763, height: 2162 } },
  { lNo: "L06", name: "Dr. Prabha Mallikarjuna", role: "Member", photo: { url: "sites/biet/leadership/l06.jpg", alt: "Dr. Prabha Mallikarjuna, Member", width: 960, height: 1280 } },
  { lNo: "L03", name: "R.L. Umashankar", role: "Member", photo: { url: "sites/biet/leadership/l03.jpg", alt: "R.L. Umashankar, Member", width: 928, height: 1144 } },
  { lNo: "L04", name: "Sri A.S. Niranjan", role: "Member", photo: { url: "sites/biet/leadership/l04.jpg", alt: "Sri A.S. Niranjan, Member", width: 1050, height: 1500 } },
  { lNo: "L05", name: "Sri Athani S. Veeranna", role: "Member", photo: { url: "sites/biet/leadership/l05.jpg", alt: "Sri Athani S. Veeranna, Member", width: 251, height: 300 } },
  { lNo: "L07", name: "Dr. H.B. Aravind", role: "Secretary", photo: { url: "sites/biet/leadership/l07.jpg", alt: "Dr. H.B. Aravind, Secretary", width: 1991, height: 2560 } },
  { lNo: "L08", name: "Prof. Y. Vrushabhendrappa", role: "Member", photo: { url: "sites/biet/leadership/l08.jpg", alt: "Prof. Y. Vrushabhendrappa, Member", width: 1991, height: 2560 } },
];
